import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { Component, OnInit } from '@angular/core';
import { CurrenciesService } from '../../../services/currencies/currencies.service';
import { Currency } from '../../../models/currencies.model';
import { TranslateService } from '@ngx-translate/core/';

@Component({
  selector: 'app-currencies',
  templateUrl: './currencies.component.html',
  styleUrls: ['./currencies.component.css'],
  providers: []
})
export class CurrenciesComponent implements OnInit {

  //currencies: Currency[] = [];
  addEditDialog = false;
  newDataAvailable = false;
  modalTitle = '';
  public titles = {};

  paginationType = KontableComponent.ServerPagination;

  constructor(
    public srvCurrency: CurrenciesService,
    private srvTranslate: TranslateService
  ) { }

  ngOnInit() {

    this.srvTranslate.get([
      'currencyList.add_title',
      'currencyList.edit_title',
    ])
    .subscribe(res => {
      this.titles['add_title'] = res['currencyList.add_title' ];
      this.titles['edit_title'] = res['currencyList.edit_title' ];
    });
/*
    this.srvCurrency.getAll().subscribe(currencies => {
      this.currencies = currencies;
    });
    */
  }

  refresh() {
    /*
    this.srvCurrency.getAll().subscribe(currencies => {
      this.currencies = currencies;
      this.newDataAvailable = true;
    });
    */
   this.newDataAvailable = true;
  }

  showAddOrEditDialog(data): void {
    this.srvCurrency.currencyEditing = data == null ? new Currency() : data;
    this.modalTitle = data == null ? this.titles['add_title'] : this.titles['edit_title'];
    this.addEditDialog = true;
  }

  closeAddDialog() {
    this.srvCurrency.currencyEditing = null;
    this.addEditDialog = false;
  }

  deleteCurrency(record): void {
    this.srvCurrency.delete(record).subscribe(() => {
      this.refresh ();
    });
  }


  currencyAdded(event): void {
    this.srvCurrency.post(event).subscribe(
      () => {
        this.closeAddDialog();
        this.refresh ();
      }
    );

  }

  currencyUpdated($event): void {
    this.srvCurrency.put($event).subscribe(() => {
        this.srvCurrency.currencyEditing = null;
        this.addEditDialog = false;
        this.refresh ();
      }
    )
  }



}



// WEBPACK FOOTER //
// ./src/app/views/administration/currencies/currencies.component.ts